import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export const loadPolicyPrognosis = (data: { polisenummer: number; utbetalingDuration?: number; prognosisAge?: number }) => (dispatch: Dispatch) => {
	const { utbetalingDuration, polisenummer, prognosisAge } = data;

	dispatch(
		actions.policyPrognosisRequest({
			utbetalingDuration,
			polisenummer,
			prognosisAge,
		}),
	);

	return server
		.getPolicyPrognosis({
			utbetalingDuration,
			polisenummer,
			prognosisAge,
		})
		.then((prognosis) => dispatch(actions.policyPrognosisResponse({ polisenummer, prognosis })))
		.catch(() =>
			dispatch(
				actions.policyPrognosisFailure({
					polisenummer,
					prognosisAge,
					utbetalingDuration,
				}),
			),
		);
};

export const resetPrognosis = () => (dispatch: Dispatch) => dispatch(actions.resetPrognosis());
